import { useFormContext, useWatch } from "react-hook-form";
import { RibbonPosition } from "@/api_framework/api_modals/HomeTileConfig";
import { RibbonPositionPicker } from "../controls";
import { cardClassName, fieldLabelClassName, IHomeTileConfigFormFields } from "../interface";

export const RibbonStyleCard = () => {
  const { control, setValue } = useFormContext<IHomeTileConfigFormFields>();
  const position = useWatch({ control, name: "ribbon.position" });

  return (
    <div className={cardClassName}>
      <div className="border-b border-slate-100 px-5 py-4">
        <div className="text-sm font-semibold text-gray-900">Ribbon Placement</div>
        <p className="mt-0.5 text-[11px] leading-4 text-gray-500">
          Where the app draws the ribbon. Ribbon colours are fixed for every tile.
        </p>
      </div>

      <div className="px-5 py-4">
        <span className={fieldLabelClassName}>Position</span>
        <RibbonPositionPicker
          value={position}
          onChange={(next: RibbonPosition) => setValue("ribbon.position", next, { shouldDirty: true })}
        />
      </div>
    </div>
  );
};
